import { render } from "./CasesStudyPage.vue?vue&type=template&id=0d25421a"
import script from "./CasesStudyPage.vue?vue&type=script&lang=js"
export * from "./CasesStudyPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/azai-web/azaitech-website-template-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__